import React from 'react';
import { motion } from 'framer-motion';
export function AchievementsSection() {
  const achievements = [{
    title: 'VELOCIDAD SOBREHUMANA',
    description: 'Haz en 10 minutos lo que antes te tomaba 4 horas. Redacta informes, correos y artículos completos en segundos. Multiplica tu producción sin trabajar más.',
    image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_epj5rcepj5rcepj5.jpg?v=1770657905',
    imageAlt: 'Persona trabajando a alta velocidad en laptop',
    align: 'left'
  }, {
    title: 'TU SEGUNDO CEREBRO',
    description: 'Delega la carga mental. Tu asistente IA organiza tu agenda, planea tus viajes y estructura tus proyectos complejos mientras tú descansas. Cero olvidos.',
    image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_l7u4ipl7u4ipl7u4.jpg?v=1770658641',
    imageAlt: 'Organización y productividad digital',
    align: 'right'
  }, {
    title: 'DISEÑADOR AL INSTANTE',
    description: '¿No eres creativo? No importa. Genera presentaciones de impacto, logotipos y gráficos profesionales describiendo lo que quieres con una sola frase.',
    image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_ouotj7ouotj7ouot.jpg?v=1770657906',
    imageAlt: 'Diseño gráfico y creatividad digital',
    align: 'left'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="space-y-28" data-id="element-3">
          {achievements.map((item, index) => <div key={index} className={`flex flex-col md:flex-row items-center gap-12 lg:gap-16 ${item.align === 'right' ? 'md:flex-row-reverse' : ''}`} data-id="element-4">
              {/* Image Side */}
              <motion.div initial={{
            opacity: 0,
            x: item.align === 'left' ? -60 : 60
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7,
            ease: 'easeOut'
          }} className="flex-1 w-full" data-id="element-5">
                <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-cyan-500/10" data-id="element-6">
                  <img src={item.image} alt={item.imageAlt} className="w-full aspect-[4/3] object-cover" data-id="element-7" />
                  {/* Subtle gradient overlay to blend with page */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/60 via-transparent to-transparent" data-id="element-8" />
                  {/* Glow behind image */}
                  <div className="absolute -inset-2 bg-cyan-500/10 blur-2xl -z-10 rounded-3xl" data-id="element-9" />
                </div>
              </motion.div>

              {/* Text Side */}
              <motion.div initial={{
            opacity: 0,
            x: item.align === 'left' ? 60 : -60
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7,
            delay: 0.15,
            ease: 'easeOut'
          }} className="flex-1 text-center md:text-left" data-id="element-10">
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-11">
                  {item.title}
                </h3>
                <p className="text-xl text-blue-100/80 leading-relaxed" data-id="element-12">
                  {item.description}
                </p>
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}